// extracted by mini-css-extract-plugin
export default {"selAlt":"SelectedAltitude_selAlt__9asB5"};